import React, { useEffect, useState } from "react";
import FlavorTabShimmer from "./FlavorTabShimmer";
import {
  Backdrop,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Pagination,
} from "@mui/material";
import AWS from "aws-sdk";
import { ServiceApi } from "../services/index.service";
import { downloadPreSellImage, getImageExtension } from "./DMBPreSellBoardsList";

const PreSellBoardsList = ({ store }) => {
  const s3 = new AWS.S3();

  const [data, setData] = useState([]);
  const [selectedPage, setSelectedPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [noimage, setNoImage] = useState("");
  const serviceapi = new ServiceApi();

  useEffect(() => {
    if (store) {
      getPreSellBoardImages();
    }
  }, []);

  const getPreSellBoardImages = async () => {
    setLoading(true);
    const req = {
      intStoreID: store?.intStoreID,
    };
    const response = await serviceapi.getpreselbanners(req);
    console.log(response);
    // const obj = {
    //   type: "flavor",
    //   banner_id: 5555,
    //   banner_name: "Flavor Board",
    //   banner_url: `drivethru-flavorboard-${store?.intRitasStoreID}-1920.jpg`,
    //   active: 1,
    //   mandatory: 1,
    //   banner_type: 1,
    //   banner_order: response?.length + 1,
    // };
    // response.push(obj);
    setNoImage("");
    setData(response);
    setLoading(false);
  };


  const imageOnLoad = (event) => {
    console.log(`Picture successfully ${event.currentTarget.src} loaded.`);
    if (event.currentTarget.className !== "error") {
      event.currentTarget.className = "success";
      setNoImage("SUCCESS");
    }
  };
  const imageOnError = (event) => {
    event.currentTarget.src = "../assets/images/noimage.jpg";
    event.currentTarget.className = "error";
    setNoImage("FAILURE");
  };

  const handleFullScreen = (UrlValue) => {
    window.open(UrlValue, "_blank");
  };

  const handlePagination = (e, pageVal) => {
    setSelectedPage(pageVal);
  };

  if (loading) {
    return (
      <div className="bg-white grid grid-cols-3 lg:grid-cols-1 gap-4 p-4">
        <FlavorTabShimmer />
        <FlavorTabShimmer />
        <FlavorTabShimmer />
        <FlavorTabShimmer />
        <FlavorTabShimmer />
        <FlavorTabShimmer />
      </div>
    );
  } else if (data?.length === 0) {
    return (
      <CardContent>
        <div
          style={{
            textAlign: "center",
          }}
        >
          Boards are not configured for this store . Kindly contact
          administrator.
        </div>
      </CardContent>
    );
  } else {
    const BannerFileName = data[selectedPage - 1]?.banner_url;
    const banner_name = data[selectedPage - 1]?.banner_name;
    const type = data[selectedPage - 1]?.type;
    const imagePath = `https://${process.env.REACT_APP_AWS_BUCKET}.s3.amazonaws.com/${process.env.REACT_APP_PRESELL_END_POINT_IMAGES}/${BannerFileName}`
    const ImageUrl = `${imagePath}?rand=${Math.floor(Math.random() * 5557654)}`
    const extension = getImageExtension(imagePath)

    return (
      <div>
        {data?.length > 0 && (
          <div className="flex justify-between py-2">
            <div>
              <h1 className="text-2xl font-display font-medium leading-tight text-secondary">
                {banner_name}
              </h1>
            </div>
            <div>
              <Pagination
                count={data?.length}
                onChange={(e, page) => handlePagination(e, page)}
                variant="outlined"
                shape="rounded"
              />
            </div>
          </div>
        )}

        <Card justify="center" alignItems="center">
          <img
            src={ImageUrl}
            onLoad={imageOnLoad}
            onError={imageOnError}
            style={{ minHeight: "320px", margin: "auto" }}
            alt="pre-sell board"
          />
          {noimage !== "" && noimage === "FAILURE" && (
            <CardContent>
              <div
                style={{
                  textAlign: "center",
                }}
              >
                Boards are not configured for this store . Kindly contact
                administrator.
              </div>
            </CardContent>
          )}
          {noimage !== "" && noimage !== "FAILURE" && (
            <CardContent
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Button
                variant="outlined"
                // onClick={() => downloadPreSellImage(ImageUrl, type)}
                onClick={() => downloadPreSellImage(ImageUrl, `${banner_name}.${extension}`)}
              >
                USB Flash Drive
              </Button>
              {/* <Button
                variant="outlined"
                onClick={() => downloadPreSellImage(ImageUrl, type)}
              >
                Media Version
              </Button> */}
              {/* Removing Streaming Button temporarily */}
              {/* <Button
                variant="outlined"
                onClick={() => handleFullScreen(ImageUrl)}
              >
                Streaming
              </Button> */}
            </CardContent>
          )}
        </Card>
      </div>
    );
  }
};

export default PreSellBoardsList;
